export const sliceName = 'whiteboardInsights';

export const getWhiteboardInsightsAction = `${sliceName}/getWhiteboardInsights`;
export const getWhiteboardInsightsFiltersAction = `${sliceName}/getWhiteboardInsightsFilters`;
